import { StyleSheet } from 'aphrodite';
import { brandPrimary, titles } from '../../../../web/styles/colors';
import { BreakPoints, CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	clipboardMessage: {
		color: '#046CB6',
		fontSize: 14,
		lineHeight: '23px',
		margin: '0 auto',
		maxWidth: 372,
		[BreakPoints.phoneCompactWidth]: {
			paddingTop: 16,
		},
	},
	body: {
		margin: '0 auto',
		position: 'relative',
		width: '63%',
		textAlign: 'left',
		[BreakPoints.phoneCompactWidth]: {
			width: 'auto',
			margin: '0 16px',
		},
	},
	bodyForeground: {
		position: 'relative',
		zIndex: 1,
	},
	container: {
		background: '#F9F9F9',
		minHeight: '100%',
		fontSize: 16,
	},
	content: {
		background: '#E8F3F9',
		borderRadius: '0 0 16px 16px',
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		padding: '32px 64px',
		[BreakPoints.phoneCompactWidth]: {
			padding: '32px 16px',
		},
	},
	feedbackContainer: {
		fontSize: 14,
	},
	feedbackContainerHeader: {
		alignItems: 'center',
		color: titles,
		display: 'flex',
		justifyContent: 'space-between',
		fontWeight: 600,
		marginBottom: 4,
	},
	feedbackInput: {
		background: '#fff',
		border: '1px solid #C6CCD7',
		height: 150,
		resize: 'none',
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		fontSize: 16,
		height: 57,
		justifyContent: 'space-evenly',
		...CssSelectors.allChildren(
			{
				display: 'flex',
				justifyContent: 'center',
				height: '100%',
				width: '100%',
				alignItems: 'center',
				...CssSelectors.allChildren(
					{
						fontWeight: 'bold',
					},
					':first-child'
				),
			},
			'*'
		),
	},
	link: {
		display: 'inline-block',
		position: 'relative',
	},
	linkContainer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: 24,
		...CssSelectors.allChildren(
			{
				height: 38,
			},
			'*'
		),
		[BreakPoints.phoneCompactWidth]: {
			flexDirection: 'column',
			...CssSelectors.allChildren(
				{
					marginTop: 16,
				},
				':not(:first-child)'
			),
		},
	},
	linkContainerCentered: {
		justifyContent: 'center',
	},
	linkContainerLeftBackgroundImage: {
		top: -71,
		left: -90,
		position: 'absolute',
		zIndex: 0,
		[BreakPoints.phoneCompactWidth]: {
			display: 'none',
		},
	},
	linkContainerRightBackgroundImage: {
		position: 'absolute',
		right: -17,
		top: -24,
		zIndex: 0,
		[BreakPoints.phoneCompactWidth]: {
			display: 'none',
		},
	},
	message: {
		marginBottom: 24,
	},
	poweredBy: {
		fontSize: 12,
		color: brandPrimary,
	},
	poweredByLogo: {
		height: 'auto',
		marginTop: 8,
		width: 158,
	},
	reviewButtonContainer: {
		position: 'relative',
	},
	reviewButtonLogo: {
		height: 38,
		position: 'absolute',
		right: 'calc(100% + 8px)',
		top: '50%',
		transform: 'translate(0%, -50%)',
		width: 38,
		[BreakPoints.tabletWidth]: {
			display: 'none',
		},
	},
	stepHeader1: {
		background: '#F9F9F9',
		border: '1px solid #E9EBEF',
		borderRadius: '16px 0 0 0',
		color: '#9198A4',
		[BreakPoints.tabletCompactWidth]: {
			display: 'none !important',
		},
		[BreakPoints.tabletWidth]: {
			...CssSelectors.allChildren(
				{
					display: 'none',
				},
				':first-child'
			),
		},
	},
	stepHeader2: {
		background: '#0066FF',
		border: '1px solid #0066FF',
		borderRadius: '0 16px 0 0',
		color: '#FFFFFF',
		[BreakPoints.tabletCompactWidth]: {
			borderRadius: '16px 16px 0 0',
		},
		[BreakPoints.tabletWidth]: {
			...CssSelectors.allChildren(
				{
					display: 'none',
				},
				':first-child'
			),
		},
	},
	surveyContainerContent: {
		paddingBottom: 74,
		paddingTop: 74,
		[BreakPoints.phoneCompactWidth]: {
			paddingBottom: 16,
			paddingTop: 16,
		},
	},
	thankyou: {
		paddingTop: 32,
	},
});
